export function toScreamingSnakeCase(str) {
    return str
        .replace(/([a-z])([A-Z])/g, '$1_$2') // Insert underscore between lowercase and uppercase letters
        .replace(/\s+/g, '_')                // Replace any spaces with underscores (if any)
        .toUpperCase();
}
